import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import GUI from "lil-gui";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { Sky } from "three/examples/jsm/Addons.js";
import gsap from "gsap";
// import holographicVertexShader from "./shaders/holographic/vertex.glsl";
// import holographicFragmentShader from "./shaders/holographic/fragment.glsl";

/**
 * Base
 */
// Debug
// const gui = new GUI();

// Wait for the window to load everything
// window.addEventListener("load", () => {
//   const loadingScreen = document.getElementById("loading-screen");

//   loadingScreen.style.transition = "opacity 20s ease-out"; // Slower opacity fade (5 seconds)
//   loadingScreen.style.opacity = 1;

//   // Simulate loading time (replace this with your actual Three.js loading logic)
//   setTimeout(() => {
//     loadingScreen.style.opacity = 0; // Fade out
//     loadingScreen.style.transition = "opacity 1s ease";

//     // Remove the loading screen after the fade-out
//     setTimeout(() => {
//       loadingScreen.style.display = "none";
//     }, 1000);
//   }, 4000); // 2-second fake load for demonstration
// });

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Models
 */
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("/draco/");

const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);

let mixer = null;
let mask = null; // Declare this at the top
let bottle = null; // Declare this at the top
let cabinet;
let selectedObject = null; // Keep track of the clicked object
const targetPosition = new THREE.Vector3(); // Position to move the object to
const clickableObjects = [];

gltfLoader.load("/models/cabinet/3d-VF2.glb", (gltf) => {
  gltf.scene.scale.set(5, 5, 5);
  scene.add(gltf.scene);

  const objectNames = [
    "Mask",
    "Bottle",
    "Ballpoint",
    "Glasses",
    "Can",
    "Phone",
    "USB",
    "Chips",
    "Headphone",
  ];
  const descriptions = {
    Mask: "[ Seen as ceremonial or protective gear. Evidence of a period of mass ritual cleansing or environmental hazards. ]",
    Bottle:
      "[ A single-use container designed to hold and transport water. Its disposable nature highlights humanity's struggle with sustainability and mass consumption. ]",
    Ballpoint:
      "[ A tool from before humans lost the skill of writing by hand. It held liquid pigment to mark processed plant sheets, now a forgotten ritual. ]",
    Glasses:
      "[ Fragile, oddly specific tools. An era where the human body required external devices to function properly. ]",
    Can: "[ A sealed vessel used to preserve perishable items, often bearing bright labels. Its structure reveals humanity's attempt to extend food's lifespan and maintain convenience. ]",
    Phone:
      "[ Perceived as ancient communication devices with mystical glowing surfaces. These were likely used for spiritual guidance, as they housed 'oracles' named Siri and Alexa]",
    USB: "[ Mysterious totemic objects with unknown data stored within. A storage medium for knowledge, possibly limited by their small physical size. ]",
    Chips:
      "[ A rigid container once used to store uniform, curved edible discs. Its design reflects humanity's desire for efficiency, symmetry, and engineered flavors. ]",
    Headphone:
      "[ Tangled wires or sleek wireless devices. Used to block out the oppressive noise of their crowded habitats. ]",
  };
  objectNames.forEach((name) => {
    const object = gltf.scene.getObjectByName(name);
    if (object) {
      clickableObjects.push(object);
      object.userData.originalPosition = object.position.clone();
      object.userData.description =
        descriptions[name] || "No description available."; // Store original position for resetting
    } else {
      console.warn(`Object '${name}' not found in GLB file.`);
    }
  });
  gltf.scene.traverse((child) => {
    if (child.isMesh && Array.isArray(child.material)) {
      child.material.forEach((mat, index) => {
        if (mat.name === "Object.001") {
          // Apply emissive effect or interaction
        }
      });
      console.log("yooo", child.material);
    }
  });

  console.log("Interactive objects loaded:", clickableObjects);
});

const backgroundScene = new THREE.Scene();
const foregroundScene = new THREE.Scene();
const textureLoader = new THREE.TextureLoader();
const emissionMap = textureLoader.load("BakingMaps/Texture-Emit.jpg");
console.log(emissionMap);
// loader.load("path/to/your/model.glb", (gltf) => {
//   gltf.scene.traverse((child) => {
//     if (child.isMesh) {
//       child.material.emissive = new THREE.Color(0xffffff); // Ensure emissive is enabled
//       child.material.emissiveMap = emissionMap; // Apply the emission texture
//       child.material.emissiveIntensity = 10; // Adjust as needed
//       child.material.needsUpdate = true; // Force update
//     }
//   });

//   scene.add(gltf.scene);
// });
// Raycaster and mouse setup
const raycaster = new THREE.Raycaster();
raycaster.params.Mesh = { threshold: 2 };
const mouse = new THREE.Vector2();

// Add event listener for clicks
// window.addEventListener("click", (event) => {
//   mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
//   mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

//   raycaster.setFromCamera(mouse, camera);
//   const intersects = raycaster.intersectObjects(clickableObjects, true);

//   if (intersects.length > 0) {
//     const clickedObject = intersects[0].object;

//     if (selectedObject === clickedObject) {
//       resetObjectPosition(clickedObject);
//       selectedObject = null;
//     } else {
//       if (selectedObject) resetObjectPosition(selectedObject);
//       selectedObject = clickedObject;
//       moveObjectToViewer(clickedObject);
//     }
//   }
// });
const overlay = document.getElementById("info-overlay");
const titleEl = document.getElementById("object-title");
const descEl = document.getElementById("object-description");
const closeButton = document.getElementById("closeButton");

function showOverlay(description) {
  const overlay = document.getElementById("info-overlay");
  const descEl = document.getElementById("object-description");

  if (descEl) {
    descEl.textContent = description; // ✅ Add the description
  } else {
    console.warn("Description element not found!");
  }

  overlay.style.display = "block"; // ✅ Make the overlay visible
}
let hoveredObject = null;
let targetPosition2 = null;
let targetPosition3 = null;
window.addEventListener("click", (event) => {
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObjects(clickableObjects, true);

  if (intersects.length > 0) {
    let clickedObject = intersects[0].object;

    // ⬇️ Traverse up to the parent if necessary
    while (clickedObject.parent && !clickableObjects.includes(clickedObject)) {
      clickedObject = clickedObject.parent;
    }

    if (selectedObject === clickedObject) {
      resetObjectPosition(clickedObject);
      selectedObject = null;
    } else {
      if (selectedObject) resetObjectPosition(selectedObject);
      selectedObject = clickedObject;
      moveObjectToViewer(clickedObject);
      showOverlay(clickedObject.userData.description);
    }

    clickedObject.updateMatrixWorld(true); // Force matrix update

    // 📍 Get world position
    const worldPosition = new THREE.Vector3();
    clickedObject.getWorldPosition(worldPosition);
    console.log("World Position:", worldPosition);

    // Capture position only when clicking the phone
    if (clickedObject.name === "Phone" && !targetPosition) {
      targetPosition = worldPosition.clone();
      console.log("Captured Phone Position:", targetPosition);
    }
    // Capture position only when clicking the phone
    if (clickedObject.name === "Mask" && !targetPosition) {
      targetPosition = worldPosition.clone();
      console.log("Captured Mask Position:", targetPosition);
    }
  } else if (selectedObject) {
    // If click happens anywhere else, reset the object
    resetObjectPosition(selectedObject);
    selectedObject = null;
    applyBackgroundBlur(false); // Remove blur when exiting view
    hideOverlay();
  }
});

function moveObjectToViewer(object) {
  if (!object.userData.originalPosition) {
    object.userData.originalPosition = object.position.clone();
    object.userData.originalScale = object.scale.clone();
  }

  // Target position in front of the camera (adjust as needed)
  const targetPosition = new THREE.Vector3(0, 0, 0); // Center of the world

  // Smoothly move object to the center and scale it up
  gsap.to(object.position, {
    x: targetPosition.x,
    y: targetPosition.y,
    z: 3,
    duration: 1,
    ease: "power2.out",
    onStart: () => applyBackgroundBlur(true), // Apply blur
  });

  gsap.to(object.scale, {
    x: 1, // Scale up (adjust as needed)
    y: 1,
    z: 1,
    duration: 1,
    ease: "power2.out",
  });

  // Make the camera look at the object
  gsap.to(camera.position, {
    x: 0,
    y: 0,
    z: 5, // Adjust this value based on how zoomed you want to be
    duration: 1,
    ease: "power2.out",
    onUpdate: () => camera.lookAt(targetPosition),
  });
}

// Hide overlay
function hideOverlay() {
  overlay.style.display = "none";
  document.getElementById("blur-overlay").style.display = "none";
}

// Close button event
closeButton.addEventListener("click", () => {
  if (selectedObject) {
    resetObjectPosition(selectedObject);
    selectedObject = null;
  }
  hideOverlay();
});

document.addEventListener("DOMContentLoaded", () => {
  // const backgroundSound = document.getElementById("background-sound");
  const soundToggleDiv = document.getElementById("sound-toggle");
  // Initialize the sound as playing
  let isSoundOn = true;

  // Function to toggle the sound
  function toggleSound() {
    if (isSoundOn) {
      backgroundSound.pause();
      soundToggleDiv.textContent = "Sound On"; // Update the div text
    } else {
      backgroundSound.play();
      soundToggleDiv.textContent = "Sound Off"; // Update the div text
    }

    // Toggle the sound state
    isSoundOn = !isSoundOn;
  }

  // Add event listener to the div (now a clickable element)
  soundToggleDiv.addEventListener("click", toggleSound);

  // Optionally start the sound when the page loads
  // backgroundSound.play();
});

// function moveObjectToViewer(object) {
//   // Save the object's original position
//   object.userData.originalPosition = object.position.clone();

//   // Get the forward direction of the camera
//   const cameraDirection = new THREE.Vector3();
//   camera.getWorldDirection(cameraDirection);

//   // **Fix diagonal movement**: Set X and Y to zero, keeping only Z
//   cameraDirection.x = 0; // Prevent sideways movement
//   cameraDirection.y = 0; // Prevent downward movement
//   cameraDirection.normalize(); // Re-normalize the direction

//   // Set how far the object should move forward
//   const moveDistance = 5; // Adjust this value to move closer or further

//   // Calculate the new target position directly in front of the camera
//   const targetPosition = new THREE.Vector3().addVectors(
//     camera.position,
//     cameraDirection.multiplyScalar(moveDistance)
//   );

//   // Animate the movement using GSAP
//   gsap.to(object.position, {
//     x: object.position.x,
//     y: object.position.y, // Keep y unchanged
//     z: targetPosition.z,
//     duration: 1,
//     ease: "power2.out",
//   });

//   console.log("Object Moving to:", targetPosition);
// }

// clickableObjects.forEach((object) => {
//   object.addEventListener("click", () => moveObjectToViewer(object));
// });

function resetObjectPosition(object) {
  if (object.userData.originalPosition) {
    gsap.to(object.position, {
      x: object.userData.originalPosition.x,
      y: object.userData.originalPosition.y,
      z: object.userData.originalPosition.z,
      duration: 1,
      ease: "power2.out",
      onComplete: () => applyBackgroundBlur(false), // Remove blur after reset
    });
  }
  gsap.to(object.scale, {
    x: 1,
    y: 1,
    z: 1,
    duration: 1,
    ease: "power2.out",
  });
  // Reset camera position if necessary (e.g., return it to its original position)
  gsap.to(camera.position, {
    z: 10, // Set the camera back to the original position (or any default position)
    duration: 1,
    ease: "power2.out",
  });
}

clickableObjects.forEach((object) => {
  object.addEventListener("click", () => {
    if (object.userData.isMoved) {
      returnObjectToShelf(object);
      object.userData.isMoved = false;
    } else {
      moveObjectToViewer(object);
      object.userData.isMoved = true;
    }
  });
});

function applyBackgroundBlur(apply) {
  const blurOverlay = document.getElementById("blur-overlay");
  blurOverlay.style.display = apply ? "block" : "none";
}

// Function to create scramble effect
document.addEventListener("DOMContentLoaded", () => {
  // Select the first item
  const firstItem = document.getElementById("left-item");

  // Function to create scramble effect
  function scrambleText(element, originalText, finalText) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let interval;
    let count = 0;

    // Scrambling effect
    const scramble = () => {
      const randomChars = Array.from({ length: originalText.length }, () => {
        return characters.charAt(Math.floor(Math.random() * characters.length));
      }).join("");
      element.textContent = randomChars;

      count++;
      if (count >= 10) {
        // Stop after 10 iterations
        clearInterval(interval);
        element.textContent = finalText; // Set the final text after scrambling
      }
    };

    interval = setInterval(scramble, 50); // Scramble every 50ms
  }

  // Add hover effect to first item (left item)
  if (firstItem) {
    // Store the original text of the first item
    const originalText = firstItem.textContent;
    const finalText = "Year 4358-XT"; // The final text after the scramble

    // Start scramble effect on mouseenter
    firstItem.addEventListener("mouseenter", () => {
      scrambleText(firstItem, originalText, finalText);
      firstItem.style.position = "relative"; // Keep it in place within flex container
    });

    // Restore original text on mouseleave
    firstItem.addEventListener("mouseleave", () => {
      firstItem.textContent = originalText;
      firstItem.style.position = ""; // Remove any custom positioning, let it stay within flex
    });
  }
});
const backgroundSound = new Audio("/music/main-music.mp3"); // Your background music file

document.addEventListener("DOMContentLoaded", () => {
  const enterButton = document.getElementById("enter-button");
  const loadingScreen = document.getElementById("loading-screen");
  const mainScene = document.getElementById("main-scene");

  // Simulate loading progress (for demonstration purposes)
  let progress = 0;
  const loadingText = document.getElementById("loading-text");
  const loadingBar = document.getElementById("loading-bar");

  // Set up the loading progress
  const loadInterval = setInterval(() => {
    if (progress < 100) {
      progress += 1; // Increment progress
      loadingText.textContent = `Loading... ${progress}%`;
      loadingBar.style.width = `${progress}%`;
    } else {
      clearInterval(loadInterval); // Stop when it reaches 100%
      // Show the "Enter" button when loading is complete
      enterButton.style.display = "inline-block"; // Make button visible
    }
  }, 50); // Simulating loading progress every 50ms

  // Hide the loading screen and show the main scene when "Enter" button is clicked
  enterButton.addEventListener("click", () => {
    // Hide the loading screen with a fade-out effect (optional)
    // Play the background music
    backgroundSound.loop = true; // Make it loop
    backgroundSound
      .play()
      .then(() => {
        backgroundSound.muted = false; // Ensure music is unmuted after playing
      })
      .catch((err) => {
        console.error("Error playing music:", err);
      });
    loadingScreen.style.transition = "opacity 1s ease-out";
    loadingScreen.style.opacity = 0;

    setTimeout(() => {
      // After fade-out is complete, hide the loading screen and show the main scene
      loadingScreen.style.display = "none";
      mainScene.style.display = "block";

      // Initialize your 3D scene or other actions when entering the scene
      init3DScene();
    }, 1000); // Delay to allow fade-out transition before hiding
  });

  // Initialize 3D scene (this is just a placeholder for your logic)
  function init3DScene() {
    // Your three.js setup and rendering code here
  }
});

window.addEventListener("mousemove", (event) => {
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObjects(clickableObjects, true);

  if (intersects.length > 0) {
    let object = intersects[0].object;

    // Traverse up if necessary
    while (object.parent && !clickableObjects.includes(object)) {
      object = object.parent;
    }

    if (hoveredObject !== object) {
      if (hoveredObject) resetHoverEffect(hoveredObject); // Reset previous hover
      hoveredObject = object;
      applyHoverEffect(hoveredObject); // Apply hover effect
      document.body.style.cursor = "pointer"; // Change cursor
    }
  } else {
    if (hoveredObject) {
      resetHoverEffect(hoveredObject); // Reset when not hovering
      hoveredObject = null;
    }
    document.body.style.cursor = "default"; // Default cursor
  }
});

function applyHoverEffect(object) {
  gsap.to(object.scale, {
    x: 1.1,
    y: 1.1,
    z: 1.1,
    duration: 0.3,
    ease: "power2.out",
  });
}

function resetHoverEffect(object) {
  gsap.to(object.scale, {
    x: 1,
    y: 1,
    z: 1,
    duration: 0.3,
    ease: "power2.inOut",
  });
}

// Initialize 3D scene (this is just a placeholder for your logic)

// const sky = new Sky();
// sky.scale.set(100, 100, 100);
// scene.add(sky);
// sky.material.uniforms["turbidity"].value = 10;
// sky.material.uniforms["rayleigh"].value = 2;
// sky.material.uniforms["mieCoefficient"].value = 0.1;
// sky.material.uniforms["mieDirectionalG"].value = 0.95;
// sky.material.uniforms["sunPosition"].value.set(0.3, -0.038, -0.95);

// scene.fog = new THREE.FogExp2("rgba(214, 113, 19, 0.19)", 0.01);
// scene.fog = new THREE.FogExp2("rgba(37, 37, 37, 0.19)", 0.01);
/**
 * Floor
 */
// const floor = new THREE.Mesh(
//   new THREE.PlaneGeometry(10, 10),
//   new THREE.MeshStandardMaterial({
//     color: "#444444",
//     metalness: 0,
//     roughness: 0.5,
//   })
// );
// floor.receiveShadow = true;
// floor.rotation.x = -Math.PI * 0.5;
// scene.add(floor);

/**
 * Lights
 */
// const ambientLight = new THREE.AmbientLight(0xffffff, 10);
// scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0x0000ff, 5);
directionalLight.position.set(5, 5, -5);
scene.add(directionalLight);

// const directionalLight2 = new THREE.DirectionalLight(0xfffff0, 2);
// directionalLight.position.set(2, 2, 5);
// scene.add(directionalLight2);

// const spotLight = new THREE.SpotLight(0x0000ff, 10); // White light, intensity = 2
// spotLight.position.set(2, 10, 200); // Position the light above the scene
// scene.add(spotLight);

const spotLight2 = new THREE.DirectionalLight(0xffffff, 5); // White light, intensity = 2
spotLight2.position.set(0, 0, 30); // Position the light above the scene
scene.add(spotLight2);

// const axesHelper = new THREE.AxesHelper(5); // The number defines the length of each axis
// scene.add(axesHelper);

const blueLight = new THREE.DirectionalLight(0x0000fff, 4);
directionalLight.position.set(5, 10, -15);
blueLight.targetPosition;
scene.add(blueLight);

// const directionalLight3 = new THREE.DirectionalLight(0xffffff, 5);
// directionalLight.castShadow = true;
// directionalLight.shadow.mapSize.set(1024, 1024);
// directionalLight.shadow.camera.far = 15;
// directionalLight.shadow.camera.left = -7;
// directionalLight.shadow.camera.top = 7;
// directionalLight.shadow.camera.right = 7;
// directionalLight.shadow.camera.bottom = -7;
// directionalLight.position.set(5, 5, 0);
// scene.add(directionalLight3);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(0, 3, 24);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.target.set(0, 0.75, 0);
controls.enableDamping = true;
controls.dampingFactor = 0.05;
controls.enablePan = false; // Completely disables panning

// Disable zooming
controls.enableZoom = false;
controls.screenSpacePanning = false; // Restrict vertical panning

// Set limits for vertical rotation (Polar angle)
controls.minPolarAngle = Math.PI / 2 - 0.01; // Lock vertical movement close to the horizon
controls.maxPolarAngle = Math.PI / 2 + 0.01; // Allow slight vertical freedom if needed

// Restrict horizontal rotation (azimuth angle)
controls.minAzimuthAngle = -Math.PI / 9; // 45 degrees to the left
controls.maxAzimuthAngle = Math.PI / 9; // 45 degrees to the right

// // Set limits for horizontal rotation (Azimuth angle)
// controls.minAzimuthAngle = -Math.PI / 4; // Limit to 45 degrees left
// controls.maxAzimuthAngle = Math.PI / 4; // Limit to 45 degrees right
// // Ensure the camera's position stays constant
// camera.position.set(0, 2.5, 24); // Set an appropriate starting position
// controls.update(); // Update the controls to apply the target and limits

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
// renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1;
// renderer.setClearColor(rendererParameters.clearColor);

// Mouse position tracking
let mouseX = 0;
let mouseY = 0;

// Mouse move event listener
function onMouseMove(event) {
  // Normalize mouse coordinates to range -1 to 1
  mouseX = (event.clientX / window.innerWidth) * 2 - 1;
  mouseY = -(event.clientY / window.innerHeight) * 2 + 1;
}

const initialCameraZ = camera.position.z;
// Apply smooth movement to the camera based on cursor position
let targetCameraPosition = new THREE.Vector3(); // Target position for the camera
let lerpSpeed = 0.03; // The smoothness of the movement (adjust as needed)

function updateCameraPosition() {
  // Calculate target position for the camera based on mouse movement
  targetCameraPosition.x = mouseX * 4; // Adjust multiplier for desired effect
  targetCameraPosition.y = mouseY * 4; // Adjust multiplier for desired effect

  // Interpolate smoothly towards the target position
  camera.position.x += (targetCameraPosition.x - camera.position.x) * lerpSpeed;
  camera.position.y += (targetCameraPosition.y - camera.position.y) * lerpSpeed;
  camera.position.z = initialCameraZ;
  // Optionally, keep the camera looking at the scene center
  camera.lookAt(scene.position);
}
// Animation loop
function animate() {
  requestAnimationFrame(animate);
  updateCameraPosition();

  if (selectedObject) {
    const time = Date.now() * 0.002; // Time-based animation
    const floatHeight = 0.2; // Amplitude of the floating effect
    const floatSpeed = 2; // Speed of the floating effect

    // Apply floating effect
    selectedObject.position.y =
      selectedObject.userData.originalPosition.y +
      Math.sin(time * floatSpeed) * floatHeight;
  }

  // Apply movement to the camera or the scene
  // camera.position.x += (mouseX * 4 - camera.position.x) * 0.03; // Smooth interpolation
  // camera.position.y += (mouseY * 4 - camera.position.y) * 0.03;

  // camera.lookAt(scene.position); // Ensure the camera keeps looking at the scene
  // Update controls to apply damping
  controls.update(); // Ensure damping happens during the update phase
  renderer.render(scene, camera);
}

animate();

window.addEventListener("mousemove", onMouseMove);
/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
